// Payment History
export const GET_PAYMENT_HISTORY = "GET_PAYMENT_HISTORY"
export const GET_PAYMENT_HISTORY_SUCCESS = "GET_PAYMENT_HISTORY_SUCCESS"
export const GET_PAYMENT_HISTORY_FAIL = "GET_PAYMENT_HISTORY_FAIL"
